// ContactForm.js
import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import axiosGeneral from "../../utils/axiosGeneral";

//** Import Assets */
import "../../assets/css/ContactUs.css";

const { TextArea } = Input;

export default function ContactForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        nameUser: values.name,
        emailUser: values.email_address,
        subject: values.subject,
        message: values.message,
      };

      const response = await axiosGeneral().post(
        `/api/activity/sendMailSupport/`,
        payload
      );

      message.success("Message sent successfully!");
      form.resetFields();
    } catch (error) {
      console.error("Error sending contact form:", error);
      message.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ maxWidth: 600, margin: "0 auto" }}
    >
      <div className="contact_container">
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter your name",
            },
          ]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>
        <Form.Item
          name="email_address"
          label="Email Address"
          rules={[
            {
              required: true,
              message: "Please enter your email address",
            },
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input type="email" placeholder="Enter your email address" />
        </Form.Item>
        <Form.Item
          name="subject"
          label="Subject"
          rules={[
            {
              required: true,
              message: "Please enter the subject of your message",
            },
          ]}
        >
          <Input placeholder="Enter the subject of your message" />
        </Form.Item>
        <Form.Item
          name="message"
          label="Message"
          rules={[
            {
              required: true,
              message: "Please enter your message",
            },
            {
              min: 10,
              message: "Message must be at least 10 characters long",
            },
          ]}
        >
          <TextArea rows={4} placeholder="Type your message..." />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {loading ? "Sending..." : "Submit"}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
}
